module.exports = __webpack_public_path__ + "static/media/choithramsVegan.1b38b628.png";